import { cn } from "@do/ui/lib/utils";
import { ScaleIcon } from "lucide-react";
import { useTranslations } from "next-intl";
import { useMemo } from "react";
import { useChat } from "../../../providers/chat-provider";
import { MarkdownRenderer } from "../../markdown-renderer";
import { HeaderSettingsSection } from "./section";

export const HeaderSettingsLegal = () => {
  const { selectedLocale, defaultLocale, chatbotParams } = useChat();
  const t = useTranslations("do-chat-v2");

  const disclaimerText = useMemo(() => {
    return (
      selectedLocale?.disclaimerText ||
      defaultLocale?.disclaimerText ||
      chatbotParams.disclaimerText
    );
  }, [selectedLocale, defaultLocale, chatbotParams.disclaimerText]);

  return (
    <HeaderSettingsSection
      id="legal"
      title={t("chat.header.settings.legal.title")}
      description={t("chat.header.settings.legal.description")}
      icon={ScaleIcon}
    >
      <div
        id="header-settings-dialog-content-section-legal-content"
        className={cn(
          "p-(--header-settings-dialog-content-section-legal-content-padding)",
          "bg-(--header-settings-dialog-content-section-legal-content-background)/(--header-settings-dialog-content-section-legal-content-background-opacity)",
          "rounded-(--header-settings-dialog-content-section-legal-content-border-radius)",
          "max-h-(--header-settings-dialog-content-section-legal-content-max-height) overflow-y-auto overscroll-none"
        )}
      >
        <MarkdownRenderer
          id="header-settings-dialog-content-section-legal-content-markdown"
          className={cn(
            "text-(--header-settings-dialog-content-section-legal-content-color)/(--header-settings-dialog-content-section-legal-content-color-opacity) text-(length:--header-settings-dialog-content-section-legal-content-font-size)",
            "font-(--header-settings-dialog-content-section-legal-content-font-weight)! font-(family-name:--header-settings-dialog-content-section-legal-content-font-family)",
            "leading-(--header-settings-dialog-content-section-legal-content-line-height)"
          )}
          text={disclaimerText ?? ""}
        />
      </div>
    </HeaderSettingsSection>
  );
};
